import { CantoImage } from '../../components/strapi/canto-image';
import { jpgPath } from '../../helpers/asset-factory';
import { trackCustomEvent } from '../../helpers/tracking-helper';

export type ConversionData = {
  link: string;
  label: string;
  onClick?: () => void;
};

export const trackFormStep = (step: number, eventName: string) => {
  const suffixes = [
    '_selection', // step 0
    '', // step 1
    '_thank_you', // step 2
  ];

  trackCustomEvent(`form_${eventName}${suffixes[step]}`);
};

export const mobileImageWidth = 426;
export const mobileImageHeight = 182;

export const getFormSideImagesWithStrapiCantoImage = (
  images: CantoImage,
  {
    desktop = { width: 1200, height: 1200 },
    mobile = { width: mobileImageWidth * 3, height: mobileImageHeight * 3 },
  }: {
    desktop?: { width: number; height: number };
    mobile?: { width: number; height: number };
  },
) => ({
  desktop: jpgPath(images.cantoDesktopImage, desktop.width, desktop.width),
  mobile: jpgPath(
    images.cantoMobileImage ?? images.cantoDesktopImage,
    mobile.width,
    mobile.height,
  ),
});
